import React from 'react';
import { ArrowRight } from 'lucide-react';
export function ServicesSection() {
  const services = [{
    title: 'Kitchen Remodeling',
    description: 'Complete kitchen transformations from custom cabinetry to high-end countertops. We build functional, beautiful spaces where your family can gather.',
    image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?auto=format&fit=crop&q=80',
    href: '#kitchens'
  }, {
    title: 'Bathroom Remodeling',
    description: 'Turn your outdated bathroom into a modern retreat. We handle everything from walk-in showers and custom vanities to complete layout changes.',
    image: 'https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80',
    href: '#bathrooms'
  }];
  return <section id="services" className="py-20 bg-gray-50 border-t border-gray-200" data-id="element-230">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-231">
        <div className="text-center mb-16" data-id="element-232">
          <h2 className="text-3xl md:text-4xl font-semibold text-brand-blue mb-4" data-id="element-233">
            What We Build
          </h2>
          <p className="text-lg text-brand-gray max-w-2xl mx-auto font-body" data-id="element-234">
            Specializing in high-quality residential remodeling for Fresno and
            Clovis homeowners.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10" data-id="element-235">
          {services.map((service, index) => <div key={index} className="group cursor-pointer flex flex-col" data-id="element-236">
              <div className="relative h-80 w-full overflow-hidden rounded mb-6" data-id="element-237">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-238" />
              </div>
              <h3 className="text-2xl font-semibold text-brand-black mb-3" data-id="element-239">
                {service.title}
              </h3>
              <p className="text-brand-gray text-lg mb-6 flex-grow font-body leading-relaxed" data-id="element-240">
                {service.description}
              </p>
              <a href={service.href} className="inline-flex items-center text-brand-blue font-semibold hover:opacity-80 transition-colors group" data-id="element-241">
                Learn More
                <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-242" />
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}